module.exports = [{"componentType":"swiss-wrestling-duel-2026","name":"Swiss Wrestling Duel 2026","hidden":true,"overlays":[],"groups":["demo","glassy"],"overlay":{"options":{}}}]


//////////////////
// WEBPACK FOOTER
// ./src/store/templates/swiss-wrestling-2026.json
// module id = 1544
// module chunks = 1